webpackJsonp([2],{

/***/ 2:
/***/ (function(module, exports) {

window.getAttachment = function (id) {
    if (id === undefined || id == '')
        return;

    var data = {
        id: id
    }

    $.ajax({
        type: 'post',
        async: false,
        url: '/config/attachments',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data.message !== undefined) {
                console.log(data);
                return;
            }

            for (var i = 0; i < data.length; i++) {
                if (data[i].type == 1) {
                    $('img[src="' + data[i].id + '"]').attr('src', data[i].url + '?w=120&h=120&s=3');
                }
                else {
                    $('img[src="' + data[i].id + '"]').remove();
                }
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
};

window.toThread = function (data, body, bdelete) {
    var newlist = '';
    var attachments = '';
    var btnhtml = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        var pichtml = '';
        if (info.attachments) {
            for (var j = 0; j < info.attachments.length; j++) {
                pichtml += '<img src="' + info.attachments[j] + '" />';
                attachments += info.attachments[j] + ',';
            }
        }
        if (bdelete)
            btnhtml = '<div class="item-btn delete" dataid="' + info.id + '"></div>';
        else
            btnhtml = '';

        if (!info.author_avatar_url) {
            info.author_avatar_url = '/static/images/no-avatar.png';
        } else {
            info.author_avatar_url += '?w=52&h=52&s=1';
        }

        newlist += '<div class="community-Item">\
            <div class="item-top">\
            <div class="item-avatar">\
            <img src="' + info.author_avatar_url + '">\
            </div>\
            <div class="item-user">\
            <div class="item-nickname">' + info.author_nickname + '</div>\
            <div class="item-time">' + info.post_time + '</div>\
            </div>\
            ' + btnhtml + '\
            </div>\
            <div class="item-middle">\
            <div class="item-picture">' + pichtml + '</div>\
            <div class="item-content part" href="' + info.url + '">' + info.content + '</div>\
            <div class="item-content-all">展开全文&nbsp∨</div> \
            </div>\
            <div class="item-bottom">\
            <div class="item-count"><div class="favorite">收藏</div></div>\
            <div class="item-count"><div class="reply">' + info.reply_count + '</div></div>\
            <div class="item-count"><div class="share">0</div></div>\
            <div class="item-count"><div class="like">点赞</div></div>\
            </div>\
            </div>';
    }

    body.append(newlist);

    getAttachment(attachments);

    $('.item-content-all').off('click');
    $('.item-content-all').on('click', function () {
        var body = $(this).parents().children('.item-content');
        if (body.hasClass('part')) {
            body.removeClass('part');
            body.addClass('all');
            $(this).text('收起全文 ∨');
        } else {
            body.removeClass('all');
            body.addClass('part');
            $(this).text('展开全文 ∧');
        }
    });
};

window.toFollow = function (data, body) {
    var newlist = '';

    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        newlist += '<div class="followItem">';
        if (info.follow_user_avatar_url == null || info.follow_user_avatar_url == '')
            info.follow_user_avatar_url = '/static/images/no-avatar.png';
        else
            info.follow_user_avatar_url += '?w=60&h=60&s=3';
        newlist += '<div class="follow-avatar"><img src="' + info.follow_user_avatar_url + '" /></div>';
        newlist += '<div class="follow-user">';
        newlist += '<div class="follow-name">' + info.follow_user_nickname + '</div>';
        if (info.signature == null || info.signature == '')
            info.signature = '';
        newlist += '<div class="follow-signature">' + info.signature + '</div>';
        newlist += '<div class="follow-btn followed" dataid="' + info.follow_user_id + '">取消关注</div>';
        newlist += '</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};

window.toFans = function (data, body) {
    var newlist = '';

    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        newlist += '<div class="fanItem">';
        if (info.fan_user_avatar_url == null || info.fan_user_avatar_url == '')
            info.fan_user_avatar_url = '/static/images/no-avatar.png';
        else
            info.fan_user_avatar_url += '?w=60&h=60&s=3';
        newlist += '<div class="fan-avatar"><img src="' + info.fan_user_avatar_url + '" /></div>';
        newlist += '<div class="fan-user">';
        newlist += '<div class="fan-name">' + info.fan_user_nickname + '</div>';
        if (info.signature == null || info.signature == '')
            info.signature = '';
        newlist += '<div class="fan-signature">' + info.signature + '</div>';
        if (info.followed)
            newlist += '<div class="follow-btn followed" dataid="' + info.fan_user_id + '">取消关注</div>';
        else
            newlist += '<div class="follow-btn" dataid="' + info.fan_user_id + '">添加关注</div>';
        newlist += '</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};

window.toLive = function (data, body, bdelete) {
    var newlist = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];

        newlist += '<div class="liveitem" data-id="' + info.id + '">\
                        <a href="' + info.url + '" target="_blank" class="liveitem-img">\
                            <img src="' + info.cover_url + '">\
                            <div class="liveitem-state">' + info.state + '</div>\
                        </a>\
                        <a href="' + info.url + '" target="_blank" class="liveitem-title">\
                            ' + info.title + '\
                        </a>\
                        <div class="liveitem-info">\
                            <div class="liveitem-username">' + info.owner_nickname + '</div>\
                            <div class="liveitem-visitor">' + info.current_visitor_count + '人参与</div>\
                        </div>';
        if (bdelete)
            newlist += '<div class="live-delete" dataid="' + info.id + '">删除</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(26);
__webpack_require__(1);
module.exports = __webpack_require__(27);


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2);

var player;

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        var index = $('.category-item.selected').attr('data-id');
        if (index == '1') {
            getThreads();
        } else if (index == '2') {
            getLives();
        } else if (index == '3') {

        } else if (index == '4') {

        } else if (index == '5') {
            getFollows();
        } else if (index == '6') {
            getFans();
        }
    }
});

$(function () {
    $('.category-item').on('click', function () {
        var index = $(this).attr('data-id');
        if (index == $('.category-item.selected').attr('data-id'))
            return;

        $('.category-item.selected').removeClass('selected');
        $(this).addClass('selected');
        $('.live-list').css('display', 'none');
        $('.community-list').css('display', 'none');
        $('.follow-list').css('display', 'none');
        $('.fan-list').css('display', 'none');

        if (index == '1') {
            getThreads();
            $('.community-list').css('display', 'block');
        } else if (index == '2') {
            getLives();
            $('.live-list').css('display', 'block');
        } else if (index == '3') {
        } else if (index == '4') {
        } else if (index == '5') {
            getFollows();
            $('.follow-list').css('display', 'block');
        } else if (index == '6') {
            getFans();
            $('.fan-list').css('display', 'block');
        }
    });

    $('.category-item[data-id=1]').click();

    $('.user-btn').on('click', function () {
        var type = $(this).attr('datatype');
        if (type == 'logout') {
            location.href = '/user/logout';
        }
    });
});

function getThreads() {
    var page = parseInt($('.community-list').attr('page'));
    var id = $('input[name=personid]').val();
    if(!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/threads?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toThread(data, $('.community-list .communityItems'));

            if (data.data.length < 5)
                $('.community-list .more').addClass('no-more');
            else
                $('.community-list .more').css('display', 'block');

            $('.community-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getLives() {
    var page = parseInt($('.live-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/lives?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toLive(data, $('.live-list .liveItems'), false);

            if (data.data.length < 8)
                $('.live-list .more').addClass('no-more');
            else
                $('.live-list .more').css('display', 'block');

            $('.live-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getFollows() {
    var page = parseInt($('.follow-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/follows?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFollow(data, $('.follow-list .followItems'));

            if (data.data.length < 10)
                $('.follow-list .more').addClass('no-more');
            else
                $('.follow-list .more').css('display', 'block');

            $('.follow-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}

function getFans() {
    var page = parseInt($('.fan-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/fans?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFans(data, $('.fan-list .fanItems'));

            if (data.data.length < 10)
                $('.fan-list .more').addClass('no-more');
            else
                $('.fan-list .more').css('display', 'block');

            $('.fan-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}

function getFavorites() {
    var page = parseInt($('.favorite-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/favorites?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFans(data, $('.fan-list .fanItems'));

            if (data.data.length < 10)
                $('.fan-list .more').addClass('no-more');
            else
                $('.fan-list .more').css('display', 'block');

            $('.fan-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}

/***/ })

},[25]);


// WEBPACK FOOTER //
// js/persond092da.js